import { useState } from "react";
import { Badge, Collapse } from "reactstrap";
import { GroupChatProfileData } from "../../../Data/Messenger/Messenger";
import { dynamicImage, Image } from "../../../Utils";

const GroupChat = () => {
  const [messages, setMessages] = useState(true);

  return (
    <div className="status">
      <div className="collapse-block open">
        <h5 className="block-title" onClick={() => setMessages(!messages)}>
          Common groups
          <Badge className="badge-outline-dark sm ms-2">3</Badge>
        </h5>
        <Collapse isOpen={messages} className="block-content">
          <ul className="group-main">
            {GroupChatProfileData.map((item, index) => (
              <li key={index}>
                <div className="group-box">
                  <div className="profile">
                    <Image className="bg-img img-fluid" src={dynamicImage(item.image)} alt="Avatar" />
                  </div>
                  <div className="details">
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Collapse>
      </div>
    </div>
  );
};

export default GroupChat;
